import * as React from 'react';
import { Button } from 'react-bootstrap';
import Dropzone from 'dropzone';
import notify from '../../../../shared/feedback/notifications';
import { previewTemplate } from '../../../../components/common/Dropzone';
import { Translate } from '../../../../shared/LanguageService';
import Api from '../../../../shared/Api';

export default class FailedImagesDropzone extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        Dropzone.autoDiscover = false;

        this.state = {
            uploading: false,
            metadataList: [],
            thumbnailTracking: {
                filesAdded: 0,
                thumbnailsLoaded: 0,
                loading: false
            }
        };

        this.processQueue = this.processQueue.bind(this);
    }

    failedImagesDropzone: Dropzone;

    componentDidMount() {
        let component = this;
        this.failedImagesDropzone = new Dropzone(
            `#failed_images_dropzone${this.props.orderRowId}`,
            {
                acceptedFiles: 'image/jpeg,image/png,image/gif,application/pdf',
                dictDefaultMessage: Translate('dropzone/title'),
                dictFallbackMessage: Translate('dropzone/fallback'),
                dictInvalidFileType: Translate('dropzone/invalid-filetype'),
                dictRemoveFile: Translate('dropzone/remove-image'),
                dictCancelUpload: Translate('dropzone/cancel-upload'),
                dictCancelUploadConfirmation: Translate('dropzone/cancel-upload-confirmation'),
                autoProcessQueue: false,
                parallelUploads: 1,
                uploadMultiple: false,
                previewTemplate: previewTemplate,
                maxThumbnailFilesize: 100,
                createImageThumbnails: true,
                init: function () {
                    let dropzone = this;
                    this.on('addedfile', (file: DropzoneFile) => {
                        if (component.props.failedFileNames.indexOf(file.name) === -1) {
                            component.failedImagesDropzone.removeFile(file);
                            notify.failure(
                                `${file.name} ${Translate(
                                    'image-processing/notification/file-name-does-not-exist'
                                )}`
                            );
                        } else if (
                            dropzone.options.acceptedFiles &&
                            !dropzone.options.acceptedFiles.includes(file.type)
                        ) {
                            component.failedImagesDropzone.removeFile(file);
                            notify.failure(`${file.name} ${Translate('dropzone/invalid-filetype')}`);
                        } else {
                            let thumbnailTracking = component.state.thumbnailTracking;
                            thumbnailTracking.filesAdded++;
                            thumbnailTracking.loading = true;
                        }
                    });

                    this.on(
                        'sending',
                        (file: DropzoneFile, xhr: XMLHttpRequest, data: FormData) => {
                            new Api().applyHeadersToXhr(xhr);
                        }
                    );

                    this.on('queuecomplete', () => {
                        component.setState({ uploading: false });
                        notify.success(Translate('image-processing/notification/images-uploaded'));
                        component.failedImagesDropzone.removeAllFiles();
                        this.options.autoProcessQueue = false;

                        if (component.props.onUploadDone) {
                            component.props.onUploadDone();
                        }
                    });

                    this.on('thumbnail', (file: any) => {
                        let thumbnailTracking = component.state.thumbnailTracking;
                        thumbnailTracking.thumbnailsLoaded++;

                        if (thumbnailTracking.thumbnailsLoaded === thumbnailTracking.filesAdded) {
                            thumbnailTracking.thumbnailsLoaded = 0;
                            thumbnailTracking.filesAdded = 0;
                            thumbnailTracking.loading = false;
                        }

                        component.setState({
                            thumbnailTracking: thumbnailTracking
                        });
                    });

                    this.on('processing', () => {
                        this.options.autoProcessQueue = true;
                    });
                }
            }
        );
    }

    processQueue() {
        this.failedImagesDropzone.processQueue();
        this.setState({ uploading: true });
    }

    render() {
        const { apiUrl } = window.appConfig;
        const formUrl = `${apiUrl}/views/orders/${this.props.orderId}/imageprocessing/rows/${this.props.orderRowId}/failedupload`;
        return (
            <div>
                <form
                    action={formUrl}
                    id={`failed_images_dropzone${this.props.orderRowId}`}
                    className="dropzone"
                ></form>
                <Button
                    onClick={() => this.processQueue()}
                    disabled={this.state.uploading || this.state.thumbnailTracking.loading}
                >
                    {Translate('image-processing/unedited/faileduploads/upload')}
                </Button>
            </div>
        );
    }
}
